import React, { Component } from "react";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import BlueButton from "../common/BlueButton"
import RedButton from "../common/RedButton"
import  WebServiceList  from '../../webservices/WebServiceList'
import axios from 'axios';

import {
  Form,
  FormGroup,
  FormTextarea,
  FormInput

} from "shards-react";



export default class NouveauMessageModal extends Component {

  constructor(props) {
    super(props);
    this.closePopUp = this.closePopUp.bind(this);
    this.onChangeMessageTitle = this.onChangeMessageTitle.bind(this);
    this.onChangeMessageDescription = this.onChangeMessageDescription.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.sendMessage = this.sendMessage.bind(this);
    this.state = {
      title: this.props.title,
      sending_list: this.props.usersId,
      message_title: "",
      message_description: "",
      redirect: false,
      open: false
    }
  }



  componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open, sending_list:nextProps.usersId});
  }



  onChangeMessageTitle(e) {
    this.setState({
      message_title: e.target.value
    });
  }

  onChangeMessageDescription(e) {
    this.setState({
      message_description: e.target.value
    });
  }

  sendMessage(e) {
    e.preventDefault();

    console.log(`Button submitted:`);

    const newMessage = {
      usersIds: this.state.sending_list,
      title: this.state.message_title,
      description: this.state.message_description
    };

    let theToken = localStorage.getItem("token");
    const headers = {
      'Content-Type': 'application/json',
      'x-access-token': theToken,
    };
    console.log("Multiple New Message:" + JSON.stringify(newMessage))

    axios.post(WebServiceList.WsSendMessage(), newMessage, {headers: headers})
      .then(res => {
        console.log(res.data);
        this.setState({ open: false });
        this.props.messageSentCallback();

      });

    this.setState({
      message_title: '',
      message_description: ''

    })
  }


  closePopUp() {
    console.log("closePopUp")
    this.props.onClosePopUp();
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div>

        <Dialog fullWidth={true} maxWidth="sm" open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Nouveau Message</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Veuillez saisir un message pour envoyer au utilisateurs séléctionnés.
              </DialogContentText>

            <Form className="quick-post-form" >
              {/* Title */}

             {/*} <FormGroup>
                <TextField
                  autoFocus
                  margin="dense"
                  id="titre"
                  label="Titre du message"
                  type="text"
                  fullWidth
                  onChange={this.onChangeMessageTitle}
                />
              </FormGroup> */}

              <FormGroup>
                <FormInput placeholder="Titre du message"
                  value={this.state.message_title}
                  onChange={this.onChangeMessageTitle} />
              </FormGroup>

              {/* Body */}
              <FormGroup>
                <FormTextarea placeholder="Descriptif du message..."
                  value={this.state.message_description}
                  onChange={this.onChangeMessageDescription}
                />
              </FormGroup>


            </Form>
          </DialogContent>
          <DialogActions>
            <BlueButton variant="contained" onClick={this.handleClose} >
              Annuler
              </BlueButton>
            <RedButton variant="contained" onClick={this.sendMessage} >
              Envoyer
              </RedButton>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}